module.exports = __webpack_public_path__ + "arrogant.4eaecc06.png";